<!-- 终端一体化解决方案 -->
<template>
  <div class="page_html">
    <banner
      :title="title"
      :subtitle="subtitle"
    />
    <div class="introduce">
      <p class="sub_title">
        终端统一安全管理需求
      </p>
      <div class="demand">
        <div class="demand_lists">
          <div
            v-for="step in demands"
            :key="step.id"
            class="demand_list"
          >
            <img
              :src="step.src"
              alt=""
            >
            <div class="text">
              {{ step.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="introduce background">
      <p class="sub_title">
        解决方案
      </p>
      <div class="solution">
        <div class="solution_lists">
          <div
            v-for="item in solutions"
            :key="item.id"
            class="solution_list"
          >
            <div class="solution_text">
              {{ item.text }}
            </div>
            <div class="solution_bottom">
              {{ item.bottom }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="introduce">
      <p class="sub_title">
        方案优势
      </p>
      <div class="advantage">
        <div class="advantageLists">
          <div
            v-for="item in advantageLists"
            :key="item.id"
            class="advantageList"
          >
            <div class="number">
              {{ item.number }}
            </div>
            <div class="title">
              {{ item.title }}
            </div>
            <div
              v-for="list in item.lists"
              :key="list"
            >
              <div class="title_list">
                {{ list }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/solution/components/banner.vue'
export default {
  name: 'TerminalIntegration',
  components: {
    banner
  },
  data() {
    return {
      title: '终端一体化解决方案',
      subtitle: '',
      demands: [
        {
          id: 1,
          src: require('@/assets/solution/terminalIntegration/shujuku.png'),

          text: '安全集成能力'
        },
        {
          id: 2,
          src: require('@/assets/solution/terminalIntegration/shujukujiami-01.png'),

          text: '恶意代码防范'
        },
        {
          id: 3,
          src: require('@/assets/solution/terminalIntegration/firewall.png'),
          num: '03',
          text: '漏洞修复'
        },
        {
          id: 4,
          src: require('@/assets/solution/terminalIntegration/tubiaozhizuomoban2-01.png'),
          num: '04',
          text: '准入控制'
        },
        {
          id: 5,
          src: require('@/assets/solution/terminalIntegration/shujukutuomin-01.png'),
          num: '05',
          text: '运维管控'
        }
      ],
      solutions: [
        {
          id: 1,
          text: '终端安全管理系统支持对蠕虫病毒、恶意软件、广告软件、勒索软件、引导区病毒、BIOS病毒的查杀，这依赖于云查引擎、启发引擎、脚本引擎、AI引擎、主防引擎(本地库)等多引擎的协同工作。',
          bottom: '病毒防护功能'

        },
        {
          id: 2,
          text: '终端安全管理系统支持对蠕虫病毒、恶意软件、广告软件、勒索软件、引导区病毒、BIOS病毒的查杀，这依赖于云查引擎、启发引擎、脚本引擎、AI引擎、主防引擎(本地库)等多引擎的协同工作。',
          bottom: '病毒防护功能'

        },
        {
          id: 3,
          text: '一体化终端安全管控系统具备非法外联管控能力，提供对非法外联的全程监视、阻断、审计和告警全过程的非法外联防控，能够彻底杜绝终端非法外联的违规行为。否成功等。',
          bottom: '违规外联功能'

        },
        {
          id: 4,
          text: '通过主动探测与被动监听方式相结合，精准识别哑终端设备，包括打卡机、打印机、扫描仪、门禁、摄像头等，并自动进行分类。支持对哑终端的指纹信息实时监测，当哑终端指纹信息变化时，可及时对其进行告警或阻断。',
          bottom: '终端准入功能'

        },
        {
          id: 5,
          text: '支持设置终端自助资产登记；解决微软停止Windows XP/Windows7系统服务带来的安全威胁，根除Windows XP/Windows7漏洞因无法修复带来的危害，满足客户业务网络已经部署的大量应用和对应用运行稳定型、持续性的要求。',
          bottom: '运维管控功能'

        }

      ],
      advantageLists: [
        {
          id: 1,
          number: '01',
          title: '终端安全一体化',
          lists: ['功能一体化', '平台一体化', '数据一体化']
        },
        {
          id: 2,
          number: '02',
          title: '病毒防御多维化',
          lists: ['多引擎技术', '立体化主防', '智能自学习', '联动处置能力']

        },
        {
          id: 3,
          number: '03',
          title: '安全管控智能化',
          lists: ['资产管理', '安全策略管理', '漏洞补丁管理', '网络安全准入', '审计管控']

        },
        {
          id: 4,
          number: '04',
          title: '全面满足合规要求',
          lists: ['对等级保护等合规要求', '中的恶意代码防范、访', '问控制、非法外联管理', ' 、资产管理、介质管理', ' 、安全审计等控制点进', '行全面覆盖。']

        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page_html {
  height: 100%;

  .demand {
    width: 70%;
    margin: 0 auto 120px;
    padding-top: 60px;

    .demand_lists {
      display: flex;
      justify-content: space-between;
    }

    .demand_list {
      width: 18%;
      height: 343px;
      border: 3px solid #D6DEF1;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      box-shadow: 0 0 5px 5px #D1D9EE;

      img {
        width: 100%;
        overflow: hidden;
      }

      .text {
        position: absolute;
        bottom: 20px;
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
      }

      .steps {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #5583E4;
        line-height: 40px;
        margin-bottom: 22px;
      }

      .demand_text {
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 40px;

      }
    }
  }

  .solution {
    width: 70%;
    margin: 0 auto 90px;

    .solution_lists {
      width: 100%;
      height: 495px;
      border-radius: 30px 30px 0px 0px;
      display: flex;
      justify-content: space-between;

      .solution_list {
        width: 18%;
        height: 495px;
        background: #FFFFFF;
        border: 1px solid #3879F6;
        border-radius: 30px 30px 0px 0px;
        position: relative;
      }
    }

    .solution_text {
      margin: 52px 20px 0;
      height: 431px;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      word-break: break-all;
    }

    .solution_bottom {
      width: 100%;
      height: 65px;
      background: #425DEC;
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 65px;
      text-align: center;
      position: absolute;
      bottom: 0;
    }

  }

  .background {
    padding: 75px 0 90px;
    background: #fafbff;
  }

  .advantage {
    width: 70%;
    margin: 0 auto 130px;
    padding-top: 45px;

    .advantageLists {
      display: flex;
      justify-content: space-between;

      .advantageList {
        width: 24%;
        height: 560px;
        background: #E1E5F8;
        border-radius: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 40px;
      }

      .number {
        width: 95px;
        height: 95px;
        background: #FFFFFF;
        border-radius: 50%;
        font-size: 48px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #425DEC;
        line-height: 95px;
        text-align: center;
        margin: 82px 0 62px;
        box-shadow: 0px 0px 9px 5px #c7d0ef;
      }

      .title {
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #425DEC;
        line-height: 40px;
        margin-bottom: 40px;
      }

      .title_list {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
      }
    }
  }

}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .page_html .demand,
  .page_html .solution,
  .page_html .advantage{
    width: 85% !important;
  }
  .page_html .solution .solution_text{
    font-size: 16px !important;
  }
   .page_html .demand .demand_list .text{
    font-size: 20px;
  }
}

@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .page_html .demand,
  .page_html .solution,
  .page_html .advantage {
    width: 80% !important;
  }
  .page_html .solution .solution_text{
    font-size: 16px !important;
  }
  .page_html .demand .demand_list .text{
    font-size: 22px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {
  .page_html .demand,
  .page_html .solution,
  .page_html .advantage {
    width: 75% !important;
  }

  .page_html .solution .solution_text{
    font-size: 19px !important;
  }
}
</style>
